import { cycloneApiClient } from '@/shared/api/core/axios-instance';

type AssetSearchParams = {
  assetTypes: 'dataset' | 'feature_set' | 'run_parameter_set' | string[];
  query?: string;
  size?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  cursor?: string;
};

export type AssetSearchResult = {
  id: number;
  type: string;
  title: string;
  description: string | null;
  run?: {
    id: number;
  } | null;
  featureSet?: {
    table: string;
  };
  dataset?: {
    table: string;
  };
};

export type AssetSearchResponse = {
  totalCount: number;
  nextCursor: string | null;
  hasMore: boolean;
  results: AssetSearchResult[];
};

export const searchAssetsByTypeApi = async (params: AssetSearchParams): Promise<AssetSearchResponse> => {
  const { data } = await cycloneApiClient.get<AssetSearchResponse>('/search/integration', {
    params,
  });
  return data;
};
